function createHelpTooltip() {
    return {
        isTooltipVisible: false,
        isMobile: window.innerWidth < 768,
        tooltipPosition: "bottom-right",
        isHovering: false,
        hideTimeout: null,

        init() {
            window.addEventListener("resize", () => {
                this.isMobile = window.innerWidth < 768;
                if (this.isTooltipVisible && this.isMobile) {
                    document.body.style.overflow = "hidden";
                }
                if (this.isTooltipVisible && !this.isMobile) {
                    this.calculatePosition();
                }
            });
        },

        calculatePosition() {
            if (!this.isTooltipVisible || this.isMobile) return;

            this.$nextTick(() => {
                const button = this.$el.querySelector("button");
                if (!button) return;

                const buttonRect = button.getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                const tooltipWidth = 320;
                const tooltipHeight = 200;

                const spaceRight = viewportWidth - buttonRect.right;
                const spaceLeft = buttonRect.left;
                const spaceTop = buttonRect.top;
                const spaceBottom = viewportHeight - buttonRect.bottom;

                let position = "bottom-right";

                if (spaceTop > tooltipHeight && spaceBottom < tooltipHeight) {
                    if (spaceRight > tooltipWidth) position = "top-right";
                    else if (spaceLeft > tooltipWidth) position = "top-left";
                    else position = "top-center";
                } else {
                    if (spaceRight > tooltipWidth) position = "bottom-right";
                    else if (spaceLeft > tooltipWidth) position = "bottom-left";
                    else position = "bottom-center";
                }

                this.tooltipPosition = position;
            });
        },

        showTooltipWithDelay() {
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
                this.hideTimeout = null;
            }
            this.isTooltipVisible = true;
            this.isHovering = true;
            if (this.isMobile) {
                document.body.style.overflow = "hidden";
            } else {
                this.calculatePosition();
            }
        },

        hideTooltipWithDelay() {
            this.isHovering = false;
            this.hideTimeout = setTimeout(() => {
                if (!this.isHovering) {
                    this.isTooltipVisible = false;
                    if (this.isMobile) document.body.style.overflow = "";
                }
            }, 200);
        },

        tooltipMouseEnter() {
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
                this.hideTimeout = null;
            }
            this.isHovering = true;
        },

        tooltipMouseLeave() {
            this.hideTooltipWithDelay();
        },

        hideTooltip() {
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
                this.hideTimeout = null;
            }
            this.isTooltipVisible = false;
            this.isHovering = false;
            if (this.isMobile) document.body.style.overflow = "";
        },

        toggleTooltip() {
            if (this.isTooltipVisible) this.hideTooltip();
            else this.showTooltipWithDelay();
        }
    };
}

window.createHelpTooltip = createHelpTooltip;
